import { MoveLeft } from 'lucide-react';

import { cn } from '@/lib/utils';

import { Button } from './ui/button';

interface NavigationBarProps {
  onBack?: () => void;
  backLabel?: string;
  stepIndicator?: string;
}

export function NavigationBar({ onBack, backLabel, stepIndicator }: NavigationBarProps) {
  const showBackButton = onBack !== undefined && backLabel !== undefined;

  if (!showBackButton && !stepIndicator) {
    return null;
  }

  return (
    <div className="flex w-full items-center justify-between">
      {showBackButton ? (
        <Button
          variant="ghost"
          type="button"
          onClick={onBack}
          className={cn(
            // Special heights/margins for focus ring display
            'text-hydrangea-500 focus-visible:ring-hydrangea-500 active:text-hydrangea-700 my-1.5 h-9 gap-1.5 text-sm font-normal hover:bg-transparent'
          )}
          aria-label={`Go back to ${backLabel}`}
        >
          <MoveLeft className="size-6" aria-hidden="true" />
          <span>{backLabel}</span>
        </Button>
      ) : (
        <div />
      )}
      {stepIndicator && (
        <span className="text-charcoal-500 text-base text-sm font-normal">{stepIndicator}</span>
      )}
    </div>
  );
}
